import DataAdapterOptionsView from "src/views/OptionsView/DataAdapterOptionsView";
import {
    AssignedModeltypeBasicDto,
    AssignmentTransferDto,
    CategoryTextSortDto,
    CategoryTextSortUpdateDto,
    CnrDto,
    DtoListWithLinksOfOptionDto,
    ExcelDownloadResponseDto,
    ExcelExportResponseDto,
    ExcelPropsDto,
    FaqDto,
    FlagDto,
    FrontendError,
    GroupDetailsDto,
    GroupDto,
    HistoryDto,
    InitDto,
    JobsDto,
    KumaCnrByRegionParams,
    KumaCnrListByRegion,
    KumaRegionListDto,
    KumaRequirementListDto,
    KumaViewDto,
    LanguageCnrDto,
    LanguageDto,
    Link,
    MaintenanceDto,
    MaintenanceListDto,
    MenuDto,
    MissingAssignmentsAndDerivateDTO,
    ModeltypeBasicCopyDto,
    ModeltypeBasicDto,
    ModelyearDto,
    NewsDto,
    OBCategoriesDto,
    OptionAWSGrammarDto,
    OptionAWSSuggestionDto,
    OptionAWSTranslateDto,
    OptionBasicDto,
    OptionBasicDtoOptionType,
    OptionBasicMYCopyConflictDto,
    OptionBasicMYCopyDto,
    OptionBasicMYCopySummaryDto,
    OptionBasicPSLDependencyDto,
    OptionBasicReferenceDto,
    OptionDifferenceDto,
    OptionDto,
    OptionFilterDto,
    OptionFlagMultiUpdateParam,
    OptionInitDto,
    OptionPreviousApprovalHistoryDto,
    OptionUpdateDto,
    OptionWorkflowStatusMultiUpdateParam,
    PDiPModeltypebasicDto,
    PDiPOptionBasicDto,
    ProMTGroupDto,
    PSLCopyConflictDto,
    PSLCopyResultSummaryDto,
    ResourceListOfCategoryTextSortDto,
    ResourceListOfCnrDto,
    ResourceListOfFaqDto,
    ResourceListOfFlagDto,
    ResourceListOfGroupDto,
    ResourceListOfImporterDto,
    ResourceListOfLanguageCnrDto,
    ResourceListOfLanguageDto,
    ResourceListOfModeltypeBasicDto,
    ResourceListOfModelyearDto,
    ResourceListOfNewsDto,
    ResourceListOfOptionBasicDto,
    ResourceListOfOptionDto,
    ResourceListOfPrivilegeDto,
    ResourceListOfProMTGroupDto,
    ResourceListOfRoleDto,
    ResourceListOfSpecConfigurationDto,
    ResourceListOfSpecDto,
    ResourceListOfTypefamilyDto,
    ResourceListOfUserDto,
    ResourceListOfWorkflowDto,
    ResourceListOfWorkflowOptionApprovalDto,
    RoleDto,
    SimpleOptionCopyDto,
    SpecConfigurationDto,
    SpecDto,
    SpecificOptionInitDto,
    TechnicalDataDto,
    TranslationServiceDto,
    UpdateDraftAssignmentsDto,
    UserDetailsDto,
    UserDto,
    UserSettingsDto,
    VersionInfoDto,
    VoteDto,
    WorkflowDto,
    WorkflowDtoType,
    WorkflowOptionApprovalDto
} from "./Client";

import {call, canExecute, getRequestProps, RequestInfos, RequestProps,} from "./HATEOASUtils";

/**
 * Interfaces for templated API links.
 * See documentation of Client class for when you need these.
 */

export interface GetPSLCopyStatsParams {
    modelyearId: number;
    typefamilyId?: number;
}

export interface GetPSLCopyConflictsParams {
    sourceModelyearId: number;
    sourceTypefamilyId: number;
    targetModelyearId: number;
    targetTypefamilyId: number;
}

export interface GetPSLCopyParams {
    sourceModelyearId: number;
    sourceTypefamilyId: number;
    targetModelyearId: number;
    targetTypefamilyId: number;
}

export interface GetOptionMTBAConflictsParams {
    cnrId: number;
}

export interface GetOBInitStatusParams {
    typeFamily: number;
    optionBasicDtoIds: number[];
}

export interface GetOBDeleteDependencyParams {
    optionBasicIds: number[];
}

export interface GetOBMYCopyStatusParams {
    sourceModelyearId: number;
    targetModelyearId: number;
}

export interface GetWorkflowOptionParams {
    typeFamily: number;
    optionBasicDtoIds: number[];
}

export interface GetOptionParams {
    cnrId: number;
    typefamilyId: number;
    metadata?: boolean;
}
export interface GetApprovalParams {
    modelYearObjectId: number;
    typeFamilyObjectId: number;
}
export interface GetApprovalCountParams {
    fromDate: String;
    toDate: String;
}
export interface GetTextsParams {
    type: string;
    lang?: string;
    query?: string;
    page?: number;
    size?: number;
}
export interface PatchTextParams {
    content: string;
}
export interface GetCategoryParams {
    modelyear: String;
    language: String;
}

export interface GetMYCategoryParams {
    modelyearId: number;
}
export interface PdipAssignedDerivatesParams {
    optionId:number;
    modelYearId:number;
}

export interface GetTechnicalDataParams {
    cnr: string;
    btyp: string;
    modelyear: number;
}

export interface GetTechnicalDataDerivatesParams {
    cnr: string;
    modelyearId: number;
    typefamilyId: number;
}

export interface GetWorkflowParitionParams {
    workflowType: WorkflowDtoType;
}

export interface GetMTBPDiPListParam {
    mj4: number;
}

export interface GetOBPDiPListParam {
    mj4: number;
}

export interface PDiPFlagParam {
    computePdipFlag: boolean;
    computePCCDFlag?: boolean;
    metadata?: boolean;
}
export interface OptionTypeParam {
    modelyear:number;
    optionCode:string;
}
export interface OptionCodeParam {
    optionCode: string;
}

interface GetParentGroupParams {
    userCn: string;
}
export interface GetMetaDataParams {
    metadata?: boolean;
}
export interface GetPSLModeltypeBasicsParams {
    typeFamilyId: number;
    cnrId: number;
}

export interface UpdateNewsPositionParams {
    toPosition: number;
}

export interface UpdateFaqPositionParams {
    toPosition: number;
}

export interface GetNewRequirementListParams {
    metadata?: boolean;
}
export interface GetOptionHistoryParams {
    language?:string;
}

export interface GetCommentSuggestionsParams {
    fragment: string;
    limit?: number;
}

export interface ChatbotCitationDto {
    text?: string;
    source?: string;
}

export interface ChatbotDto {
    message?: string;
    answer?: string;
    citations?: ChatbotCitationDto[];
    links?: { [key: string]: Link };
}

/**
 * Interface for the most basic type of back end requests.
 */
interface IRequestExecution<TResult, TArgument> {
    /**
     * Executes the request.
     * This method is supposed to throw if the request can't be executed.
     *
     * @param data optional argument to be sent with the request
     * @returns the Promise of the request
     */
    execute(data?: TArgument): Promise<TResult>;
}

/**
 * Interface for most back end requests.
 */
export interface ICheckedRequestExecution<TResult, TArgument> extends IRequestExecution<TResult, TArgument> {
    /**
     * Checks if the request can be executed or not.
     *
     * @returns true if the request can be executed, false otherwise.
     *          true is no guarantee that the request will succeed but
     *          ensure the request has all necessary information to execute
     *          the request itself (such as the required link/url).
     */
    canExecute(): boolean;
}

/**
 * Execute a request to receive the base links from the back end.
 */
class GetBaseLinksExecution implements IRequestExecution<MenuDto, undefined> {
    /**
     * @param baseUrl callback to get the baseUrl for the underlying axios call
     * @param token callback to get the authentication token for the request
     */
    constructor(private baseUrl: () => string, private token: () => string) {
    }

    public execute(): Promise<MenuDto> {
        return call<MenuDto>(this.baseUrl(), this.token(), {info: RequestInfos.get, url: "/"});
    }
}

/**
 * Execute a generic request.
 */
class RequestExecution<TResult, TArgument> implements ICheckedRequestExecution<TResult, TArgument> {
    /**
     * @param baseUrl callback to get the baseUrl for the underlying axios call
     * @param token callback to get the authentication token for the request
     * @param verb the API verb (link name) of the request
     * @param linkContainer the Dto that's supposed to contain the links for the given verb, or the link with rel equal to given verb
     */
    constructor(
        private baseUrl: () => string,
        private token: () => string,
        private verb: string,
        private linkContainer: any) {
    }

    public canExecute(): boolean {
        return canExecute(this.verb, this.linkContainer);
    }

    public execute(data?: TArgument): Promise<TResult> {
        let requestProps = getRequestProps(this.verb, this.linkContainer, data);
        if (requestProps.url.indexOf('?') > 0) {
            data = undefined;
        }
        return call<TResult>(this.baseUrl(), this.token(), requestProps, data);
    }
}

// type alias' for better readability
type IRE<T, A = undefined> = IRequestExecution<T, A>;
type ICRE<T, A = undefined> = ICheckedRequestExecution<T, A>;

export class Client {
    /**
     * Type safe interface to the back end API.
     *
     * If you require access to a back end endpoint that's not yet listed here:
     * - make sure back end devs (actively!) support the API you require; this
     *   list must be manually modified if any API changes in the back end
     * - find a good name and add it to the list;  the API verb is usually a good
     *   name (such as "GET_adminArea" or "POST_role") but need to be modified in
     *   case it's already used in another context (see "GET_currentUserInfo" vs.
     *   "GET_self")
     * - if the API call requires an input argument:
     *   - import the required data structure (usually *Dto) from Client.ts
     *   - add the imported data type as ARGUMENT_TYPE to your API method (see request format below)
     * - if the API call requires template parameters:
     *   - create an interface that contains all template params at the top of this file
     *   - add the created data type as ARGUMENT_TYPE to your API method (see request format below)
     * - if the API call requires an input argument and template parameters:
     *   - not supported (but easy to implement)
     *
     * Request format:
     * GET|POST|PATCH|DELETE_GoodName = ([LINK_CONTAINER]): ICRE<RETURN_TYPE, ARGUMENT_TYPE> => new RequestExecution(baseUrl, token, API_VERB, [LINK_CONTAINER])
     *
     * LINK_CONTAINER: An object that contains a "links" property. If LINK_CONTAINER["links"]
     *                 contains the API_VERB property, the request is executable and
     *                 canExecute() returns true.
     * RETURN_TYPE:    The return type of the back end API. If the request to the server is
     *                 successful, the response will be case to this type.
     * ARGUMENT_TYPE:  The type of request argument or undefined if the request doesn't take
     *                 arguments. The argument (if any) is passed to the execute() method.
     *                 The argument is either the request body required by the API or an object
     *                 containing all template parameters required by the API.
     * API_VERB:       The name of the link that the back end uses to identify a certain
     *                 functionality.
     */

    /* tslint:disable:variable-name */
    /* tslint:disable:max-line-length */

    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** General links start */
    POST_error = (linkContainer: MenuDto): ICRE<string, FrontendError> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_error", linkContainer);

    GET_baseLinks = (): IRE<MenuDto> => new GetBaseLinksExecution(this.getBaseUrl, this.getToken);
    GET_initdata = (linkContainer: MenuDto): ICRE<InitDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_initData", linkContainer);
    GET_currentUserInfo = (linkContainer: MenuDto): ICRE<UserDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_self", linkContainer);
    GET_currentUserDetails = (linkContainer: MenuDto): ICRE<UserDetailsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_userDetails", linkContainer);
    GET_languageList = (linkContainer: MenuDto): ICRE<ResourceListOfLanguageDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_languageList", linkContainer);
    GET_modelyearList = (linkContainer: MenuDto): ICRE<ResourceListOfModelyearDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modelyearList", linkContainer);
    GET_typefamilies = (linkContainer: ModelyearDto): ICRE<ResourceListOfTypefamilyDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_typefamilies", linkContainer);
    GET_cnrList = (linkContainer: MenuDto): ICRE<ResourceListOfCnrDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_cnrList", linkContainer);
    GET_basicMarketCnr = (linkContainer: MenuDto): ICRE<CnrDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_basicMarketCnr", linkContainer);
    GET_importerList = (linkContainer: MenuDto): ICRE<ResourceListOfImporterDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_importerList", linkContainer);
    GET_OBCategories = (linkContainer: MenuDto): ICRE<OBCategoriesDto, GetCategoryParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_OBCategories", linkContainer);
    GET_version_info = (linkContainer: MenuDto): ICRE<VersionInfoDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_version_info", linkContainer);

    PATCH_userSettings = (linkContainer: MenuDto): ICRE<Link, UserDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_userSettings", linkContainer);
    /** General links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** Admin area related links start */
    GET_adminArea = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_adminArea", linkContainer);
    /** ------------------------ */
    /** User related links start */
    POST_user = (linkContainer: ResourceListOfUserDto): ICRE<Link, UserDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_user", linkContainer);

    GET_userDetails = (linkContainer: UserDto): ICRE<UserDetailsDto, string> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_userDetails", linkContainer);
    GET_userGroupsOptionTypes = (linkContainer: UserDto): ICRE<OptionBasicDtoOptionType[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_userGroupsOptionTypes", linkContainer);
    GET_userList = (linkContainer: MenuDto): ICRE<ResourceListOfUserDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_userList", linkContainer);

    PATCH_user = (linkContainer: UserDto): ICRE<Link, UserDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_user", linkContainer);

    DELETE_user = (linkContainer: UserDto): ICRE<any, UserDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_user", linkContainer);
    /** User related links end */
    /** ------------------------- */
    /** ProMT Group related links start */
    POST_group = (linkContainer: ResourceListOfGroupDto): ICRE<Link, GroupDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_group", linkContainer);

    GET_groupDetails = (linkContainer: GroupDto): ICRE<GroupDetailsDto, string> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_groupDetails", linkContainer);
    GET_indirectParentGroups = (linkContainer: MenuDto): ICRE<ResourceListOfGroupDto, GetParentGroupParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_indirectParentGroups", linkContainer);
    GET_directParentGroups = (linkContainer: MenuDto): ICRE<ResourceListOfGroupDto, GetParentGroupParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_directParentGroups", linkContainer);
    GET_groupList = (linkContainer: MenuDto): ICRE<ResourceListOfGroupDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_groupList", linkContainer);

    PATCH_group = (linkContainer: GroupDto): ICRE<Link, GroupDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_group", linkContainer);

    DELETE_group = (linkContainer: GroupDto): ICRE<any, GroupDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_group", linkContainer);
    /** ProMT Group related links end */
    /** ------------------------- */
    /** Group related links start */
    POST_proMTGroup = (linkContainer: ResourceListOfProMTGroupDto): ICRE<Link, ProMTGroupDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_proMTGroup", linkContainer);
    GET_proMTGroupList = (linkContainer: MenuDto): ICRE<ResourceListOfProMTGroupDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_proMTGroupList", linkContainer);
    PATCH_proMTGroup = (linkContainer: ProMTGroupDto): ICRE<Link, ProMTGroupDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_proMTGroup", linkContainer);
    DELETE_proMTGroup = (linkContainer: ProMTGroupDto): ICRE<any, ProMTGroupDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_proMTGroup", linkContainer);
    /** Group related links end */
    /** ------------------------- */
    /** Roles related links start */
    POST_role = (linkContainer: ResourceListOfRoleDto): ICRE<Link, RoleDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_role", linkContainer);

    GET_roleList = (linkContainer: MenuDto): ICRE<ResourceListOfRoleDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_roleList", linkContainer);

    PATCH_role = (linkContainer: RoleDto): ICRE<Link, RoleDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_role", linkContainer);

    DELETE_role = (linkContainer: RoleDto): ICRE<any, RoleDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_role", linkContainer);
    /** Roles related links end */
    /** ------------------------------ */
    /** Priviledge related links start */
    GET_privilegeList = (linkContainer: MenuDto): ICRE<ResourceListOfPrivilegeDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_privilegeList", linkContainer);
    /** Priviledge related links end */
    /** ---------------------------- */
    /** Workflow related links start */
    POST_workflow = (linkContainer: ResourceListOfWorkflowDto): ICRE<Link, WorkflowDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_workflow", linkContainer);

    GET_workflowSelf = (linkContainer: Link): ICRE<WorkflowDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_workflowSelf", linkContainer);
    GET_workflows = (linkContainer: MenuDto): ICRE<ResourceListOfWorkflowDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_workflows", linkContainer);
    GET_workflow_partitions = (linkContainer: MenuDto): ICRE<string[], GetWorkflowParitionParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_workflowPartitions", linkContainer);

    UPDATE_workflow = (linkContainer: WorkflowDto): ICRE<Link, WorkflowDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_workflow", linkContainer);

    DELETE_workflow = (linkContainer: WorkflowDto): ICRE<void, WorkflowDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_workflow", linkContainer);
    /** Workflow related links start */
    /** ---------------------------- */
    /** Specs related links start */
    POST_spec = (linkContainer: ResourceListOfSpecDto): ICRE<Link, SpecDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_spec", linkContainer);

    GET_specSelf = (linkContainer: Link): ICRE<SpecDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_specSelf", linkContainer);
    GET_specs = (linkContainer: MenuDto): ICRE<ResourceListOfSpecDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_specs", linkContainer);

    PATCH_spec = (linkContainer: SpecDto): ICRE<Link, SpecDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_spec", linkContainer);

    DELETE_spec = (linkContainer: SpecDto): ICRE<any, SpecDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_spec", linkContainer);
    /** Specs related links end */
    /** ----------------------------------------------- */
    /** Specification configuration related links start */
    POST_specConfig = (linkContainer: MenuDto): ICRE<Link, SpecConfigurationDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_specConfig", linkContainer);

    GET_specConfigList = (linkContainer: MenuDto): ICRE<ResourceListOfSpecConfigurationDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_specConfigList", linkContainer);

    PATCH_specConfig = (linkContainer: MenuDto): ICRE<Link, SpecConfigurationDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_specConfig", linkContainer);

    DELETE_specConfig = (linkContainer: MenuDto): ICRE<any, SpecConfigurationDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_specConfig", linkContainer);
    /** Specification configuration related links end */

    /** Flag related links start */
    POST_flag = (linkContainer: ResourceListOfFlagDto): ICRE<Link, FlagDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_flag", linkContainer);
    GET_flags = (linkContainer: MenuDto): ICRE<ResourceListOfFlagDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_flags", linkContainer);
    GET_flagSelf = (linkContainer: Link): ICRE<SpecDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_flagSelf", linkContainer);
    PATCH_flag = (linkContainer: FlagDto): ICRE<Link, FlagDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_flag", linkContainer);
    DELETE_flag = (linkContainer: FlagDto): ICRE<void, FlagDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_flag", linkContainer);
    /** Flag related links end */

    /** News related links start */
    POST_news = (linkContainer: ResourceListOfNewsDto): ICRE<Link, NewsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_news", linkContainer);
    GET_news = (linkContainer: MenuDto): ICRE<ResourceListOfNewsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_news", linkContainer);
    GET_activeNews = (linkContainer: MenuDto): ICRE<NewsDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_activeNews", linkContainer);
    PATCH_moveNews = (linkContainer: NewsDto): ICRE<void, UpdateNewsPositionParams> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_moveNews", linkContainer);
    PATCH_news = (linkContainer: NewsDto): ICRE<Link, NewsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_news", linkContainer);
    DELETE_news = (linkContainer: NewsDto): ICRE<void, NewsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_news", linkContainer);
    /** News related links end */

    /** FAQ related links start */
    POST_faq = (linkContainer: ResourceListOfFaqDto): ICRE<Link, FaqDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_faq", linkContainer);
    GET_faq = (linkContainer: MenuDto): ICRE<ResourceListOfFaqDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_faq", linkContainer);
    GET_activeFaq = (linkContainer: MenuDto): ICRE<FaqDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_activeFaq", linkContainer);
    PATCH_moveFaq = (linkContainer: FaqDto): ICRE<void, UpdateFaqPositionParams> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_moveFaq", linkContainer);
    PATCH_faq = (linkContainer: FaqDto): ICRE<Link, FaqDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_faq", linkContainer);
    DELETE_faq = (linkContainer: FaqDto): ICRE<void, FaqDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_faq", linkContainer);
    /** FAQ related links end */

    /** Admin area related links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** PSL related links start */
    POST_option_with_context = (linkContainer: MenuDto): ICRE<Link, OptionInitDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_option_with_context", linkContainer);
    POST_optionCopy = (linkContainer: ResourceListOfOptionDto): ICRE<Link, SimpleOptionCopyDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_optionCopy", linkContainer);
    POST_specificOption = (linkContainer: ResourceListOfOptionDto): ICRE<ResourceListOfOptionDto, SpecificOptionInitDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_specificOption", linkContainer);
    POST_pslCopy = (linkContainer: MenuDto): ICRE<PSLCopyResultSummaryDto, GetPSLCopyParams> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_pslCopy", linkContainer);
    POST_ExcelExport = (linkContainer: ResourceListOfOptionDto): ICRE<ExcelExportResponseDto, OptionFilterDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_ExcelExport", linkContainer);
    POST_excelExportV2 = (linkContainer: ResourceListOfOptionDto): ICRE<ExcelExportResponseDto, ExcelPropsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_excelExportV2", linkContainer);
    POST_excelExportV2_grid = (linkContainer: ResourceListOfOptionDto): ICRE<ExcelExportResponseDto, ExcelPropsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_excelExportV2_grid", linkContainer);
    GET_optionSelf = (linkContainer: Link): ICRE<OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionSelf", linkContainer);
    GET_optionSelfLinks = (linkContainer: OptionDto): ICRE<OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionSelf", linkContainer);
    GET_optionList = (linkContainer: ModelyearDto): ICRE<ResourceListOfOptionDto, GetOptionParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionList", linkContainer);
    GET_optionIndicators = (linkContainer: OptionDto): ICRE<OptionDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionIndicators", linkContainer);
    GET_optionCopyAssignmentsConflicts = (linkContainer: OptionDto): ICRE<{[key: string]: String[]}, GetOptionMTBAConflictsParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionCopyAssignmentsConflicts", linkContainer);
    GET_optionUpdateAssignmentsConflicts = (linkContainer: OptionDto): ICRE<{[key: string]: String[]}> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionUpdateAssignmentsConflicts", linkContainer);
    GET_optionChilds = (linkContainer: OptionDto): ICRE<ResourceListOfOptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionChilds", linkContainer);
    GET_optionDifference = (linkContainer: OptionDto): ICRE<OptionDifferenceDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionDifference", linkContainer);
    GET_ExcelDownload = (linkContainer: ExcelExportResponseDto): ICRE<ExcelDownloadResponseDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_excelDownload", linkContainer);
    GET_excelDownloadV2 = (linkContainer: ExcelExportResponseDto): ICRE<ExcelDownloadResponseDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_excelDownloadV2", linkContainer);
    GET_pslCopyStats = (linkContainer: MenuDto): ICRE<{[key: number]: number}, GetPSLCopyStatsParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_pslCopyStats", linkContainer);
    GET_pslCopyConflicts = (linkContainer: MenuDto): ICRE<PSLCopyConflictDto[], GetPSLCopyConflictsParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_pslCopyConflicts", linkContainer);
    GET_workflowsOption = (linkContainer: MenuDto): ICRE<{[key: number]: WorkflowDto[]}, GetWorkflowOptionParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_workflowsOption", linkContainer);
    GET_validOptionWorkflows = (linkContainer: OptionDto): ICRE<{[key: number]: WorkflowDto[]}, GetWorkflowOptionParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_workflowsOption", linkContainer);
    GET_pslExtraLinks = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_pslExtraLinks", linkContainer);
    GET_pslPCCDSynchronisation = (linkContainer: ResourceListOfOptionDto): ICRE<MissingAssignmentsAndDerivateDTO> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_pslPCCDSynchronisation", linkContainer);
    GET_optionSelfHistory = (linkContainer: OptionDto): ICRE<HistoryDto[], GetOptionHistoryParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionSelfHistory", linkContainer);
    GET_approvalViewOptionSelfHistory = (linkContainer: WorkflowOptionApprovalDto): ICRE<HistoryDto[], GetOptionHistoryParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionSelfHistory", linkContainer);
    GET_LastApprovalOptionHistory = (linkContainer: WorkflowOptionApprovalDto): ICRE<OptionPreviousApprovalHistoryDto, number> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_LastApprovalOptionHistory", linkContainer);
    GET_pdipAssignedDerivates =(linkContainer: ResourceListOfOptionDto): ICRE<AssignedModeltypeBasicDto[], PdipAssignedDerivatesParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_pdipAssignedDerivates", linkContainer);
    GET_pslFilters = (linkContainer: MenuDto): ICRE<{[key: number]: number}, GetPSLCopyStatsParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_pslFilters", linkContainer);

    PATCH_option = (linkContainer: OptionDto): ICRE<Link, OptionUpdateDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_option", linkContainer);
    PATCH_optionReset = (linkContainer: OptionDto): ICRE<Link, OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionReset", linkContainer);
    PATCH_optionTexts = (linkContainer: OptionDto): ICRE<Link, OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionTexts", linkContainer);
    PATCH_optionPackage = (linkContainer: OptionDto): ICRE<Link, OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionPackage", linkContainer);
    PATCH_optionConstraint = (linkContainer: OptionDto): ICRE<Link, OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionConstraint", linkContainer);
    PATCH_optionExclusion = (linkContainer: OptionDto): ICRE<Link, OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionExclusion", linkContainer);
    PATCH_optionFlag = (linkContainer: OptionDto): ICRE<Link, OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionFlag", linkContainer);
    PATCH_optionModeltypeAssignments = (linkContainer: OptionDto): ICRE<Link, OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionModeltypeAssignments", linkContainer);
    PATCH_specificIndependentOption = (linkContainer: OptionDto): ICRE<Link> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_specificIndependentOption", linkContainer);
    PATCH_optionTranferAssignments = (linkContainer: ResourceListOfOptionDto): ICRE<{[key: number]: string}, AssignmentTransferDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionTranferAssignments", linkContainer);
    PATCH_optionWorkflowStatusMultiUpdate = (linkContainer: ResourceListOfOptionDto): ICRE<number, OptionWorkflowStatusMultiUpdateParam> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionWorkflowStatusMultiUpdate", linkContainer);
    PATCH_optionDraftAssignments = (linkContainer: ResourceListOfOptionDto): ICRE<{[key: number]: string}, UpdateDraftAssignmentsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionDraftAssignments", linkContainer);
    PATCH_optionFlagsMultiUpdate =(linkContainer: ResourceListOfOptionDto): ICRE<DataAdapterOptionsView[], OptionFlagMultiUpdateParam> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionFlagsMultiUpdate", linkContainer);

    DELETE_option = (linkContainer: OptionDto): ICRE<void, OptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_option", linkContainer);
    DELETE_optionMultipleDelete = (linkContainer: ResourceListOfOptionDto): ICRE<number[], DtoListWithLinksOfOptionDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionMultipleDelete", linkContainer);
    /** PSL related links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** Base option related links start */
    POST_optionBasic = (linkContainer: ResourceListOfOptionBasicDto): ICRE<OptionBasicDto, OptionBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_optionBasic", linkContainer);
    POST_optionBasicMYCopy = (linkContainer: MenuDto): ICRE<OptionBasicMYCopySummaryDto, OptionBasicMYCopyDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_optionBasicMYCopy", linkContainer);

    GET_optionBasic = (linkContainer: Link): ICRE<OptionBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicSelf", linkContainer);
    GET_optionBasicList = (linkContainer: ModelyearDto): ICRE<ResourceListOfOptionBasicDto, PDiPFlagParam> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicList", linkContainer);
    GET_optionBasicPDiPList = (linkContainer: MenuDto): ICRE<PDiPOptionBasicDto[], GetOBPDiPListParam> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicPDiPList", linkContainer);
    GET_optionBasicDependency = (linkContainer: ResourceListOfOptionBasicDto): ICRE<{[key: number]: OptionBasicPSLDependencyDto}, GetOBDeleteDependencyParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicDependency", linkContainer);
    GET_optionBasicInitStatus = (linkContainer: MenuDto): ICRE<{[key: number]: boolean}, GetOBInitStatusParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicInitStatus", linkContainer);
    GET_optionBasicMYCopyConflict = (linkContainer: MenuDto): ICRE<OptionBasicMYCopyConflictDto[], GetOBMYCopyStatusParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicMYCopyConflict", linkContainer);
    GET_optionBasicExtraLinks = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicExtraLinks", linkContainer);
    GET_optionBasicReferences = (linkContainer: OptionBasicDto): ICRE<OptionBasicReferenceDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicReferences", linkContainer);
    GET_optionBasicSelfHistory = (linkContainer: OptionBasicDto): ICRE<HistoryDto[], GetOptionHistoryParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicSelfHistory", linkContainer);

    PATCH_optionBasic = (linkContainer: OptionBasicDto): ICRE<Link, OptionBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_optionBasic", linkContainer);

    DELETE_optionBasic = (linkContainer: OptionBasicDto): ICRE<any, OptionBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_optionBasic", linkContainer);
    DELETE_multiple_deletion = (linkContainer: any): ICRE<any, Array<number>> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_multiple_deletion", linkContainer);
    GET_optionBasicOptionType = (linkContainer: MenuDto): ICRE<ResourceListOfOptionBasicDto,OptionTypeParam> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionBasicOptionType", linkContainer);
    GET_setInactiveOptionCode=(linkContainer: MenuDto): ICRE<ResourceListOfOptionBasicDto,OptionCodeParam> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_setInactiveOptionCode", linkContainer);
    GET_checkPccdSynchronization = (linkContainer: MenuDto): ICRE<MissingAssignmentsAndDerivateDTO> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_checkPccdSynchronization", linkContainer);
    /** Base option related links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** Modeltype basic related links start */
    POST_modeltypeBasicCopy = (linkContainer: MenuDto): ICRE<void, ModeltypeBasicCopyDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_modeltypeBasicCopy", linkContainer);
    POST_modeltypeBasic = (linkContainer: MenuDto): ICRE<Link, ModeltypeBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_modeltypeBasic", linkContainer);

    GET_modeltypeBasicSelf = (linkContainer: Link): ICRE<ModeltypeBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicSelf", linkContainer);
    GET_modeltypeBasicColors = (linkContainer: MenuDto): ICRE<string[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicColors", linkContainer);
    GET_modeltypeBasicList = (linkContainer: ModelyearDto): ICRE<ResourceListOfModeltypeBasicDto, PDiPFlagParam> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicList", linkContainer);
    GET_modeltypeBasicPDiPList = (linkContainer: MenuDto): ICRE<PDiPModeltypebasicDto[], GetMTBPDiPListParam> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicPDiPList", linkContainer);
    GET_modeltypeBasicPSLConnections = (linkContainer: ModeltypeBasicDto): ICRE<{[key: number]: number;}, ModeltypeBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicPSLConnections", linkContainer);
    GET_modeltypeBasicPSLList = (linkContainer: ModelyearDto): ICRE<ResourceListOfModeltypeBasicDto, GetPSLModeltypeBasicsParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicPSLList", linkContainer);
    GET_modeltypeBasicSelfHistory = (linkContainer: ModeltypeBasicDto): ICRE<HistoryDto[], GetOptionHistoryParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicSelfHistory", linkContainer);

    GET_modeltypeBasicExtraLinks = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicExtraLinks", linkContainer);
    PATCH_modeltypeBasic = (linkContainer: ModeltypeBasicDto): ICRE<Link, ModeltypeBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_modeltypeBasic", linkContainer);

    DELETE_modeltypeBasic = (linkContainer: ModeltypeBasicDto): ICRE<void, ModeltypeBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_modeltypeBasic", linkContainer);
    GET_modeltypeBasicPCCDSync = (linkContainer: MenuDto): ICRE<string[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modeltypeBasicPCCDSync", linkContainer);
    /** Modeltype basic related links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** Technical data related links start */
    GET_technicalData = (linkContainer: MenuDto): ICRE<TechnicalDataDto[], GetTechnicalDataParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_technicalDataList", linkContainer);
    GET_technicalDataDerivates = (linkContainer: MenuDto): ICRE<ModeltypeBasicDto[], GetTechnicalDataDerivatesParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_technicalDataDerivates", linkContainer);

    /** Technical data area related links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** Approval related links start */
    POST_approvals = (linkContainer: ResourceListOfWorkflowOptionApprovalDto): ICRE<Link, WorkflowOptionApprovalDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_processWorkflowList", linkContainer);

    GET_approvals = (linkContainer: MenuDto): ICRE<ResourceListOfWorkflowOptionApprovalDto, GetApprovalParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_workflowApprovalList", linkContainer);
    GET_approvals_count = (linkContainer: MenuDto): ICRE<ResourceListOfWorkflowOptionApprovalDto, GetApprovalCountParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_adminApprovalCount", linkContainer);
    GET_approvals_count_by_typefamily = (linkContainer: MenuDto, typefamilyId: number): ICRE<any, GetApprovalCountParams> => {
        /* tslint:disable:no-string-literal */
        const links = linkContainer ? (linkContainer as any)["links"] : undefined;
        const countLink = links ? links["GET_adminApprovalCount"] as Link : undefined;
        const baseHref = countLink && countLink.href ? countLink.href.replace(/\{?\?.*$/, "") : "";
        const typefamilyLink = { rel: "GET_adminApprovalCountByTypefamily", href: baseHref ? baseHref + "/typefamily/" + typefamilyId : "", templated: true } as Link;
        /* tslint:enable:no-string-literal */
        return new RequestExecution(this.getBaseUrl, this.getToken, "GET_adminApprovalCountByTypefamily", typefamilyLink);
    }

    /** Approval related links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** Support area related links start */
    GET_supportArea = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_supportArea", linkContainer);
    GET_monitoring = (linkContainer: MenuDto): ICRE<string> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_monitoring", linkContainer);
    /** Support area related links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** Category Sort area related links start */
    GET_modelyearCategories = (linkContainer: MenuDto): ICRE<ResourceListOfCategoryTextSortDto, GetMYCategoryParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_modelyearCategories", linkContainer);

    PATCH_moveCategory = (linkContainer: CategoryTextSortDto): ICRE<void, CategoryTextSortUpdateDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_moveCategory", linkContainer);
    /** Category Sort area related links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */
    /** Language area related links start */
    GET_cnrLanguages = (linkContainer: MenuDto): ICRE<ResourceListOfLanguageCnrDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_cnrLanguages", linkContainer);
    PATCH_assignLanguageCnr = (linkContainer: LanguageCnrDto): ICRE<Link, LanguageCnrDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_assignLanguageCnr", linkContainer);
    GET_cnrAssignedLanguages = (linkContainer: CnrDto): ICRE<LanguageDto[], number> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_cnrAssignedLanguages", linkContainer);
    /** Language area related links end */
    /** Kuma area links start */
    GET_kumaExtraLinks = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_kumaExtraLinks", linkContainer);
    GET_kumaRegionList = (linkContainer: MenuDto): ICRE<KumaRegionListDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_kumaRegionList", linkContainer);
    GET_architectureSystemList = (linkContainer: MenuDto): ICRE<string[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_architectureSystemList", linkContainer);
    GET_kumaTypefamilyList = (linkContainer: MenuDto): ICRE<ResourceListOfTypefamilyDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_kumaTypefamilyList", linkContainer);
    GET_kumaRequirementList = (linkContainer: MenuDto): ICRE<KumaRequirementListDto, GetNewRequirementListParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_kumaRequirementList", linkContainer);
    POST_kumaRequirement =(linkContainer: MenuDto): ICRE<Link, KumaViewDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_kumaRequirement", linkContainer);
    GET_kumaRequirementSelf = (linkContainer: Link): ICRE<KumaViewDto,GetMetaDataParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_kumaRequirementSelf", linkContainer);
    PATCH_kumaRequirement =(linkContainer: MenuDto): ICRE<Link, KumaViewDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_kumaRequirement", linkContainer);
    DELETE_kumaRequirementList=(linkContainer: MenuDto): ICRE<Link, KumaViewDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "DELETE_kumaRequirementList", linkContainer);
    GET_kumaManagement = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_kumaManagement", linkContainer);
    GET_kumaCnrList =(linkContainer: MenuDto): ICRE<KumaCnrListByRegion,KumaCnrByRegionParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_kumaCnrList", linkContainer);
    POST_kumaRequirementVote =(linkContainer: MenuDto): ICRE<Link, VoteDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_kumaRequirementVote", linkContainer);
    PATCH_kumaRequirement_change_workflow_status =(linkContainer: MenuDto): ICRE<Link, KumaViewDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_kumaRequirement_change_workflow_status", linkContainer);
    PATCH_updateUserData = (linkContainer: MenuDto): ICRE<Link, UserSettingsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_updateUserData", linkContainer);
    PATCH_kuma_requirement_update =(linkContainer: MenuDto): ICRE<Link, KumaViewDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_kuma_requirement_update", linkContainer);
    GET_kuma_dertivates = (linkContainer: MenuDto): ICRE<ResourceListOfModeltypeBasicDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_kuma_dertivates", linkContainer);
    /** Kuma area links end */

    /** Management Overview area links start  */
    GET_managementBusinessArea = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_managementBusinessArea", linkContainer);
    GET_getJobs = (linkContainer: MenuDto): ICRE<MenuDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_getJobs", linkContainer);
    PATCH_updateJobByName = (linkContainer: MenuDto): ICRE<Link,JobsDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_updateJobByName", linkContainer);
    GET_promtChatCatArea =(linkContainer: MenuDto): ICRE<ChatbotDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_promtChatCatArea", linkContainer);
    /* Management Overview area links end */

    /** Texts (reusable comment TextObjects) area links start */
    GET_texts = (linkContainer: MenuDto): ICRE<any, GetTextsParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_texts", linkContainer);
    GET_textUsages = (linkContainer: MenuDto, textId: number): ICRE<any> => {
        /* tslint:disable:no-string-literal */
        const links = linkContainer ? (linkContainer as any)["links"] : undefined;
        const textsLink = links ? links["GET_texts"] as Link : undefined;
        const baseHref = textsLink && textsLink.href ? textsLink.href.replace(/\{?\?.*$/, "") : "";
        const usagesLink = { rel: "GET_textUsages", href: baseHref ? baseHref + "/" + textId + "/usages" : "" } as Link;
        /* tslint:enable:no-string-literal */
        return new RequestExecution(this.getBaseUrl, this.getToken, "GET_textUsages", usagesLink);
    }
    PATCH_texts = (linkContainer: MenuDto, textId: number): ICRE<Link, PatchTextParams> => {
        /* tslint:disable:no-string-literal */
        const links = linkContainer ? (linkContainer as any)["links"] : undefined;
        const textsLink = links ? links["GET_texts"] as Link : undefined;
        const baseHref = textsLink && textsLink.href ? textsLink.href.replace(/\{?\?.*$/, "") : "";
        const patchLink = { rel: "PATCH_texts", href: baseHref ? baseHref + "/" + textId : "" } as Link;
        /* tslint:enable:no-string-literal */
        return new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_texts", patchLink);
    }
    /** Texts area links end */

    /** Maintenance Text area links start */
    GET_maintenanceStatus = (linkContainer: MenuDto): ICRE<MaintenanceListDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_maintenanceStatus", linkContainer);
    PATCH_maintenanceStatus = (linkContainer: MenuDto): ICRE<Link,MaintenanceDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_maintenanceStatus", linkContainer);
    /** Maintenance Text area links end */
    /** ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */

    POST_filterApprovals =  (linkContainer: MenuDto): ICRE<Link, WorkflowOptionApprovalDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_filterApprovals", linkContainer);
    GET_approvalCount = (linkContainer: MenuDto): ICRE<InitDto> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_approvalCount", linkContainer);
    GET_translationService = (linkContainer: MenuDto): ICRE<TranslationServiceDto[]> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_translationService", linkContainer);
    PATCH_translationService = (linkContainer: MenuDto): ICRE<Link, TranslationServiceDto> => new RequestExecution(this.getBaseUrl, this.getToken, "PATCH_translationService", linkContainer);
    POST_optionAWSTranslate= (linkContainer: ResourceListOfOptionDto): ICRE<Link, OptionAWSTranslateDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_optionAWSTranslate", linkContainer);
    GET_optionCommentSuggestions = (linkContainer: ResourceListOfOptionDto): ICRE<any[], GetCommentSuggestionsParams> => new RequestExecution(this.getBaseUrl, this.getToken, "GET_optionCommentSuggestions", linkContainer);
    POST_optionBasicAWSTranslate= (linkContainer: ResourceListOfOptionDto): ICRE<Link, OptionAWSTranslateDto> => new RequestExecution(this.getBaseUrl, this.getToken, "POST_optionBasicAWSTranslate", linkContainer);
    /* tslint:disable:variable-name */
    POST_awsBedrockGrammar = (linkContainer: MenuDto): ICRE<OptionAWSGrammarDto, OptionAWSGrammarDto> =>
    new RequestExecution(this.getBaseUrl, this.getToken, "POST_awsBedrockGrammar", linkContainer)

    constructor(private _baseUrl?: string, private _token?: string) {
    }

    public GET_awsBedrockGenerateText = (objectId: number): { execute: () => Promise<OptionAWSSuggestionDto> } => {
        return {
            execute: () => {
                const requestProps = {
                    url: `/aws-bedrock/generateLongText/${objectId}`,
                    info: {
                        method: 'GET',
                        _method: 'GET',
                        status: 200,
                        _status: 200,
                        isExpectedStatus: (status: number) => status === 200
                    },
                };
                return call<OptionAWSSuggestionDto>(this.getBaseUrl(), this.getToken(), requestProps as any, {});
            }
        };
    }

    public POST_promtChatCat = (linkContainer: ChatbotDto): { execute: (data: ChatbotDto) => Promise<ChatbotDto> } => {
        return {
            execute: (data: ChatbotDto) => {
                const requestProps = getRequestProps("POST_promtChatCat", linkContainer, data);
                requestProps.info = {
                    method: 'post',
                    status: [200],
                    isExpectedStatus: (status: number): boolean => [200].indexOf(status) > -1
                } as any;
                return call<ChatbotDto>(this.getBaseUrl(), this.getToken(), requestProps as RequestProps, data);
            }
        };
    }

    /**
     * Check whether the client is configured with an authentication token.
     * The token may be invalid; requests can fail even if this method is true.
     *
     * @returns true if the client is configured with an authentication token, false otherwise
     */
    public isAuthenticated(): boolean {
        return this._token !== undefined && this._token !== "";
    }

    /**
     * Set the base url to be used with all requests.
     */
    public set baseUrl(value: string | undefined) {
        this._baseUrl = value;
    }

    /**
     * Set the token to be used with all requests.
     */
    public set token(value: string | undefined) {
        this._token = value;
    }

    private getBaseUrl = (): string => {
        return this._baseUrl ? this._baseUrl : "";
    }

    private getToken = (): string => {
        return this._token ? this._token : "";
    }
    public getOptionTypeUsingId=(id:number)=> {
        const requestProps = {
            url:`/optionBasics/${id}/optionType`,
            info:{
                method:'GET',
                isExpectedStatus : (status: number): boolean => (
                    [200].indexOf(status) > -1
                  )
            },
        };
        return call<any>(this.getBaseUrl(), this.getToken(), requestProps as RequestProps);
    }
    public getHistoryByWorkflowId=(id:number)=> {
        const requestProps = {
            url:`/history/workflow/${id}`,
            info:{
                method:'GET',
                isExpectedStatus : (status: number): boolean => (
                    [200].indexOf(status) > -1
                  )
            },
        };
        return call<any>(this.getBaseUrl(), this.getToken(), requestProps as RequestProps);
    }
    public getOSPRetrieveAll=()=> {
        const requestProps = {
            url:`/ospGeneration/retrieveAll`,
            info:{
                method:'GET',
                isExpectedStatus : (status: number): boolean => (
                    [200].indexOf(status) > -1
                  )
            },
        };
        return call<any>(this.getBaseUrl(), this.getToken(), requestProps as RequestProps);
    }
    public getGenerationByTypeFamilyId=(id:number)=> {
        const requestProps = {
            url:`/ospGeneration/typefamily/${id}`,
            info:{
                method:'GET',
                isExpectedStatus : (status: number): boolean => (
                    [200].indexOf(status) > -1
                  )
            },
        };
        return call<any>(this.getBaseUrl(), this.getToken(), requestProps as RequestProps);
    }
    public getOptionUsingPagination=(filters:any,pslData:any,page:number,pageSize:number)=> {
        const requestProps = {
            url:`/v2/options/${pslData.modelyear}?cnrId=${pslData.cnrId}&typefamilyId=${pslData.typefamilyId}&metadata=true&page=${page}&size=${pageSize}`,
            info:{
                method:'POST',
                isExpectedStatus : (status: number): boolean => (
                    [200].indexOf(status) > -1
                  )
            },

        };
        return call<any>(this.getBaseUrl(), this.getToken(), requestProps as RequestProps,filters);
    }
}

export default Client;



// WEBPACK FOOTER //
// ./src/services/HATEOASClient.ts